// import React from "react";
// import { useNavigate } from "react-router-dom";

// function BillingStatic() {
//   const navigate = useNavigate();

//   return (
//     <div className="container my-5">
//       <div className="row justify-content-center">
//         <div className="col-md-8">
//           <h3 className="fw-bold mb-4 text-center">Billing Details</h3>

//           <div className="p-4 shadow-sm border rounded-3">
//             {/* Name */}
//             <div className="row mb-3">
//               <div className="col-md-6">
//                 <input className="form-control" placeholder="First Name" />
//               </div>
//               <div className="col-md-6">
//                 <input className="form-control" placeholder="Last Name" />
//               </div>
//             </div>

//             {/* Company */}
//             <div className="mb-3">
//               <input
//                 className="form-control"
//                 placeholder="Company Name (Optional)"
//               />
//             </div>

//             {/* Address */}
//             <div className="mb-3">
//               <input className="form-control" placeholder="Street Address" />
//             </div>

//             {/* Location */}
//             <div className="row mb-3">
//               <div className="col-md-3">
//                 <select className="form-select">
//                   <option>Country</option>
//                   <option>India</option>
//                 </select>
//               </div>
//               <div className="col-md-3">
//                 <select className="form-select">
//                   <option>State</option>
//                 </select>
//               </div>
//               <div className="col-md-3">
//                 <select className="form-select">
//                   <option>City</option>
//                 </select>
//               </div>
//               <div className="col-md-3">
//                 <input className="form-control" placeholder="Zip Code" />
//               </div>
//             </div>

//             {/* Contact */}
//             <div className="row mb-4">
//               <div className="col-md-6">
//                 <input className="form-control" placeholder="Email Address" />
//               </div>
//               <div className="col-md-6">
//                 <input className="form-control" placeholder="Phone Number" />
//               </div>
//             </div>

//             {/* Button */}
//             <button
//               className="bg-col text-white border-0 w-100 py-2 fw-bold rounded-2"
//               onClick={() => navigate("/payment")}
//             >
//               CONTINUE TO PAYMENT
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BillingStatic;




// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// function BillingStatic() {
//   const navigate = useNavigate();

//   const [addressType, setAddressType] = useState("Home");
//   const [defaultAddress, setDefaultAddress] = useState(false);
//   const [selectedAddress, setSelectedAddress] = useState(null);

//   // 🔹 Static saved addresses (baad me API se)
//   const [savedAddresses] = useState([
//     {
//       id: 1,
//       type: "Home",
//       address: "Andheri West, Mumbai",
//       pincode: "400058",
//     },
//     {
//       id: 2,
//       type: "Office",
//       address: "Bandra East, Mumbai",
//       pincode: "400051",
//     },
//   ]);

//   return (
//     <div className="container my-5">
//       <div className="row justify-content-center">
//         <div className="col-md-8">
//           <h3 className="fw-bold mb-4">Add New Address</h3>

//           {/* ================= ADD ADDRESS FORM ================= */}
//           <div className="p-4 shadow-sm border rounded-3 mb-4">
//             <div className="mb-3">
//               <label className="fw-semibold">Pin Code *</label>
//               <input className="form-control" placeholder="Enter Pin Code" />
//             </div>

//             <div className="mb-3">
//               <label className="fw-semibold">Address *</label>
//               <input className="form-control" placeholder="House No, Street" />
//             </div>

//             <div className="mb-3">
//               <label className="fw-semibold">Location *</label>
//               <input className="form-control" placeholder="Area / Locality" />
//             </div>

//             <div className="row mb-3">
//               <div className="col-md-6">
//                 <label className="fw-semibold">City *</label>
//                 <input className="form-control" placeholder="City" />
//               </div>
//               <div className="col-md-6">
//                 <label className="fw-semibold">State *</label>
//                 <input className="form-control" placeholder="State" />
//               </div>
//             </div>

//             {/* Address Type */}
//             <div className="mb-3">
//               <label className="fw-semibold d-block">ADDRESS TYPE</label>
//               <label className="me-3">
//                 <input
//                   type="radio"
//                   checked={addressType === "Home"}
//                   onChange={() => setAddressType("Home")}
//                 />{" "}
//                 Home
//               </label>
//               <label>
//                 <input
//                   type="radio"
//                   checked={addressType === "Office"}
//                   onChange={() => setAddressType("Office")}
//                 />{" "}
//                 Office
//               </label>
//             </div>

//             {/* Default Address */}
//             <div className="form-check mb-3">
//               <input
//                 type="checkbox"
//                 className="form-check-input"
//                 checked={defaultAddress}
//                 onChange={() => setDefaultAddress(!defaultAddress)}
//               />
//               <label className="form-check-label">
//                 Make this my Default Address
//               </label>
//             </div>

//             <button className="bg-col text-white border-0 px-4 py-2 fw-bold rounded-2">
//               ADD ADDRESS
//             </button>
//           </div>

//           {/* ================= SAVED ADDRESS LIST ================= */}
//           <h5 className="fw-bold mb-3">Saved Addresses</h5>

//           {savedAddresses.map((item) => (
//             <div
//               key={item.id}
//               className="border p-3 rounded-2 mb-2 d-flex gap-2 align-items-start"
//             >
//               <input
//                 type="radio"
//                 name="savedAddress"
//                 onChange={() => setSelectedAddress(item)}
//               />
//               <div>
//                 <strong>{item.type}</strong>
//                 <p className="mb-0">{item.address}</p>
//                 <small>Pin: {item.pincode}</small>
//               </div>
//             </div>
//           ))}

//           {/* ================= CONTINUE ================= */}
//           <button
//             disabled={!selectedAddress}
//             className="bg-col text-white border-0 w-100 py-2 fw-bold mt-4 rounded-2"
//             onClick={() => navigate("/payment")}
//           >
//             CONTINUE TO PAYMENT
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BillingStatic;




// Static code start
// import React from "react";
// import { Link } from "react-router-dom";

// function BillingStatic() {
//   return (
//     <div className="container my-5">
//       <h4 className="fw-bold mb-4">BILLING DETAILS</h4>

//       <div className="row g-4">
//         {/* ================= LEFT SECTION ================= */}
//         <div className="col-md-8">
//           <div className="border p-4 rounded-2">

//             {/* Billing Info */}
//             <h6 className="fw-bold mb-3">Billing Information</h6>

//             <div className="row mb-3">
//               <div className="col-md-6">
//                 <input className="form-control" placeholder="First Name" />
//               </div>
//               <div className="col-md-6">
//                 <input className="form-control" placeholder="Last Name" />
//               </div>
//             </div>

//             <div className="mb-4">
//               <input className="form-control" placeholder="Company Name" />
//             </div>

//             {/* Address */}
//             <h6 className="fw-bold mb-3">ADDRESS</h6>

//             <div className="mb-3">
//               <input className="form-control" placeholder="Pin Code*" />
//             </div>

//             <div className="mb-3">
//               <input className="form-control" placeholder="Address*" />
//             </div>

//             <div className="mb-3">
//               <input className="form-control" placeholder="Location*" />
//             </div>

//             <div className="row mb-3">
//               <div className="col-md-6">
//                 <input className="form-control" placeholder="City*" />
//               </div>
//               <div className="col-md-6">
//                 <input className="form-control" placeholder="State*" />
//               </div>
//             </div>

//             {/* Address Type */}
//             <div className="mb-2">
//               <strong>ADDRESS TYPE</strong>
//             </div>

//             <div className="mb-2">
//               <label className="me-3">
//                 <input type="radio" name="type" defaultChecked /> Home
//               </label>
//               <label>
//                 <input type="radio" name="type" /> Office
//               </label>
//             </div>

//             <div className="form-check mb-3">
//               <input className="form-check-input" type="checkbox" />
//               <label className="form-check-label">
//                 Make this my Default Address
//               </label>
//             </div>

//             <button className="bg-col text-white w-100 py-2 border-0 rounded-2 fw-bold mb-4">
//               ADD ADDRESS
//             </button>

//             {/* Saved Addresses */}
//             <h6 className="fw-bold mb-3">SAVED ADDRESSES</h6>

//             <div className="border rounded-2 p-3 d-flex justify-content-between align-items-center">
//               <div className="d-flex gap-2">
//                 <input type="radio" defaultChecked />
//                 <div>
//                   <p className="mb-1">
//                     Ahead of Amravati University, Mardi road
//                   </p>
//                   <small>Amravati, Maharashtra - 444901</small>
//                   <div className="fw-bold">Home</div>
//                 </div>
//               </div>

//               <button className="bg-col text-white border-0 px-3 py-1 rounded-2">
//                 DELIVER HERE
//               </button>
//             </div>

//             {/* Email / Phone */}
//             <div className="row mt-4">
//               <div className="col-md-6">
//                 <input className="form-control" placeholder="Email" />
//               </div>
//               <div className="col-md-6">
//                 <input className="form-control" placeholder="Phone" />
//               </div>
//             </div>

//           </div>
//         </div>

//         {/* ================= RIGHT SECTION ================= */}
//         <div className="col-md-4">
//           <div className="border p-4 rounded-2">
//             <h6 className="fw-bold mb-3">Order Summary</h6>

//             <div className="d-flex justify-content-between mb-2">
//               <span>Mat Rehna School Ke Bharose | Hindi Book</span>
//               <span>2 × ₹344.00</span>
//             </div>

//             <div className="d-flex justify-content-between mb-3">
//               <span>Hijama tyfhjk Black Hijama Suction Gun</span>
//               <span>2 × ₹678.00</span>
//             </div>

//             <hr />

//             <div className="fw-bold mb-3">Total ₹3840</div>

//            <Link to="/payment"><button className="bg-col text-white w-100 py-2 border-0 rounded-2 fw-bold">
//               Payment Continue
//             </button></Link> 
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default BillingStatic;
//Static code end




// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Link, useNavigate } from "react-router-dom";

// const BASE_URL = "https://ecom.cyberathon.com";

// function BillingStatic() {
//   const navigate = useNavigate();
//   const userId = sessionStorage.getItem("userId");
//   const cartToken = localStorage.getItem("cart_token");

//   /* ================= CART ================= */
//   const [cartItems, setCartItems] = useState([]);

//   useEffect(() => {
//     if (!userId && !cartToken) return;

//     axios
//       .post(`${BASE_URL}/index.php/Api/list_cart`, {
//         user_id: userId ? userId : null,
//         cart_token: userId ? null : cartToken,
//       })
//       .then(res => {
//         if (res.data.status) setCartItems(res.data.cart_items);
//       });
//   }, [userId, cartToken]);

//   const totalAmount = cartItems.reduce(
//     (sum, i) => sum + Number(i.current_price) * Number(i.cart_qty),
//     0
//   );
// //   const userId = sessionStorage.getItem("userId");

//   const [form, setForm] = useState({
//     first_name: "",
//     last_name: "",
//     company_name: "",
//     address1: "",
//     location: "",
//     city: "",
//     state: "",
//     pin_code: "",
//     email: "",
//     phone: "",
//     address_type: "home",
//     add_information: "",
//   });

//   const [addresses, setAddresses] = useState([]);
//   const [selectedAddress, setSelectedAddress] = useState(null);

//   /* 🔐 LOGIN CHECK */
//   useEffect(() => {
//     if (!userId) {
//       alert("Please login first");
//     //   navigate("/login");
//     }
//   }, [userId, navigate]);

//   /* 📥 FETCH SAVED ADDRESSES */
//   const loadAddresses = async () => {
//     try {
//       const res = await axios.post(
//         `${BASE_URL}/index.php/Api/list_billing_address`,
//         { user_id: userId }
//       );
//       if (res.data.status) {
//         setAddresses(res.data.data || []);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   useEffect(() => {
//     loadAddresses();
//   }, []);

//   /* 📝 HANDLE INPUT */
//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   /* ➕ ADD ADDRESS */
//   const addAddress = async () => {
//     try {
//       const payload = { ...form, user_id: userId };
//       const res = await axios.post(
//         `${BASE_URL}/index.php/Api/add_billing_address`,
//         payload
//       );

//       if (res.data.status) {
//         alert("Address added successfully");
//         setForm({
//           first_name: "",
//           last_name: "",
//           company_name: "",
//           address1: "",
//           location: "",
//           city: "",
//           state: "",
//           pin_code: "",
//           email: "",
//           phone: "",
//           address_type: "home",
//           add_information: "",
//         });
//         loadAddresses();
//       }
//     } catch (err) {
//       console.error(err);
//       alert("Failed to add address");
//     }
//   };

//   return (
//     <div className="container my-5">
//       <h4 className="fw-bold mb-4">BILLING DETAILS</h4>

//       <div className="row g-4">
//         {/* LEFT */}
//         <div className="col-md-8">
//           <div className="border p-4 rounded-2">

//             <h6 className="fw-bold mb-3">Billing Information</h6>

//             <div className="row mb-3">
//               <div className="col-md-6">
//                 <input name="first_name" value={form.first_name} onChange={handleChange} className="form-control" placeholder="First Name" />
//               </div>
//               <div className="col-md-6">
//                 <input name="last_name" value={form.last_name} onChange={handleChange} className="form-control" placeholder="Last Name" />
//               </div>
//             </div>

//             <input name="company_name" value={form.company_name} onChange={handleChange} className="form-control mb-3" placeholder="Company Name" />

//             <h6 className="fw-bold mb-3">ADDRESS</h6>

//             <input name="pin_code" value={form.pin_code} onChange={handleChange} className="form-control mb-2" placeholder="Pin Code" />
//             <input name="address1" value={form.address1} onChange={handleChange} className="form-control mb-2" placeholder="Address" />
//             <input name="location" value={form.location} onChange={handleChange} className="form-control mb-2" placeholder="Location" />

//             <div className="row mb-3">
//               <div className="col-md-6">
//                 <input name="city" value={form.city} onChange={handleChange} className="form-control" placeholder="City" />
//               </div>
//               <div className="col-md-6">
//                 <input name="state" value={form.state} onChange={handleChange} className="form-control" placeholder="State" />
//               </div>
//             </div>

//             <strong>ADDRESS TYPE</strong>
//             <div className="mb-3">
//               <label className="me-3">
//                 <input type="radio" checked={form.address_type === "home"} onChange={() => setForm({ ...form, address_type: "home" })} /> Home
//               </label>
//               <label>
//                 <input type="radio" checked={form.address_type === "office"} onChange={() => setForm({ ...form, address_type: "office" })} /> Office
//               </label>
//             </div>

//             <button onClick={addAddress} className="bg-col text-white w-100 py-2 border-0 rounded-2 fw-bold mb-4">
//               ADD ADDRESS
//             </button>

//             {/* SAVED ADDRESSES */}
//             <h6 className="fw-bold mb-3">SAVED ADDRESSES</h6>

//             {addresses.map((addr) => (
//               <div key={addr.billing_id} className="border rounded-2 p-3 d-flex justify-content-between mb-3">
//                 <label className="d-flex gap-2">
//                   <input type="radio" name="selectAddress" onChange={() => setSelectedAddress(addr)} />
//                   <div>
//                     <p className="mb-1">{addr.address1}</p>
//                     <small>{addr.city}, {addr.state} - {addr.pin_code}</small>
//                     <div className="fw-bold text-capitalize">{addr.address_type}</div>
//                   </div>
//                 </label>

//                 <button onClick={() => setSelectedAddress(addr)} className="bg-col text-white border-0 px-3 py-1 rounded-2">
//                   DELIVER HERE
//                 </button>
//               </div>
//             ))}

//           </div>
//         </div>

//         {/* RIGHT */}
//         {/* <div className="col-md-4">
//           <div className="border p-4 rounded-2">
//             <h6 className="fw-bold mb-3">Order Summary</h6>

//             <div className="fw-bold mb-3">Total ₹3840</div>

//             <Link to="/payment">
//               <button disabled={!selectedAddress} className="bg-col text-white w-100 py-2 border-0 rounded-2 fw-bold">
//                 Payment Continue
//               </button>
//             </Link>
//           </div>
//         </div> */}
//         <div className="col-md-4 py-5">
//             <div className="border p-4 shadow-sm">
//               <h5>Order Summary</h5>

//               {cartItems.map(item=>(
//                 <div key={item.cart_id} className="d-flex justify-content-between">
//                   <span>{item.Product_name}</span>
//                   <span>{item.cart_qty} x ₹{item.current_price}</span>
//                 </div>
//               ))}

//               <hr />
//               <strong>Total ₹{totalAmount}</strong>

//               {/* <button
//                 onClick={handlePlaceOrder}
//                 className="bg-col border-0 p-2 w-100 mt-3 rounded text-white fw-bold"
//               >
//                 PLACE ORDER
//               </button> */}
//             </div>
//           </div>
//       </div>
//     </div>
//   );
// }

// export default BillingStatic;


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// const BASE_URL = "https://ecom.cyberathon.com";

// function BillingStatic() {
//   const navigate = useNavigate();

//   const userId = sessionStorage.getItem("userId"); // null if guest
//   const cartToken = localStorage.getItem("cart_token");

//   /* ================= LOGIN POPUP ================= */
//   const [showLoginAlert, setShowLoginAlert] = useState(false);

//   useEffect(() => {
//     if (!userId) {
//       setShowLoginAlert(true);
//     }
//   }, [userId]);

//   /* ================= CART ================= */
//   const [cartItems, setCartItems] = useState([]);

//   useEffect(() => {
//     if (!userId && !cartToken) return;

//     axios
//       .post(`${BASE_URL}/index.php/Api/list_cart`, {
//         user_id: userId ? userId : null,
//         cart_token: userId ? null : cartToken,
//       })
//       .then((res) => {
//         if (res.data.status) {
//           setCartItems(res.data.cart_items);
//         } else {
//           setCartItems([]);
//         }
//       })
//       .catch(() => setCartItems([]));
//   }, [userId, cartToken]);

//   const totalAmount = cartItems.reduce(
//     (sum, i) => sum + Number(i.current_price) * Number(i.cart_qty),
//     0
//   );

//   /* ================= FORM ================= */
//   const [form, setForm] = useState({
//     first_name: "",
//     last_name: "",
//     company_name: "",
//     address1: "",
//     location: "",
//     city: "",
//     state: "",
//     pin_code: "",
//     email: "",
//     phone: "",
//     address_type: "home",
//     add_information: "",
//   });

//   const [addresses, setAddresses] = useState([]);
//   const [selectedAddress, setSelectedAddress] = useState(null);

//   /* ================= LOAD ADDRESSES (ONLY LOGIN) ================= */
//   const loadAddresses = async () => {
//     try {
//       const res = await axios.post(
//         `${BASE_URL}/index.php/Api/list_billing_address`,
//         { user_id: userId }
//       );

//       if (res.data.status) {
//         setAddresses(res.data.data || []);
//       } else {
//         setAddresses([]);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   useEffect(() => {
//     if (userId) loadAddresses();
//   }, [userId]);

//   /* ================= HANDLE FORM ================= */
//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   /* ================= ADD ADDRESS ================= */
//   const addAddress = async () => {
//     if (!userId) return;

//     try {
//       const res = await axios.post(
//         `${BASE_URL}/index.php/Api/add_billing_address`,
//         { ...form, user_id: userId }
//       );

//       if (res.data.status) {
//         alert("Address added successfully");
//         setForm({
//           first_name: "",
//           last_name: "",
//           company_name: "",
//           address1: "",
//           location: "",
//           city: "",
//           state: "",
//           pin_code: "",
//           email: "",
//           phone: "",
//           address_type: "home",
//           add_information: "",
//         });
//         loadAddresses();
//       }
//     } catch (err) {
//       alert("Failed to add address");
//     }
//   };

//   /* ================= PAYMENT ================= */
//   const handlePayment = () => {
//     if (!userId || !selectedAddress) return;
//     navigate("/payment");
//   };

//   return (
//     <div className="container my-5">
//       <h4 className="fw-bold mb-4">BILLING DETAILS</h4>

//       {/* ================= LOGIN POPUP ================= */}
//       {showLoginAlert && (
//         <div className="alert alert-warning text-center">
//           <b>Please login to continue</b>
//           <div className="mt-2">
//             <button
//               className="btn btn-sm btn-primary"
//               onClick={() => setShowLoginAlert(false)}
//             >
//               OK
//             </button>
//           </div>
//         </div>
//       )}

//       <div className="row g-4">
//         {/* ================= LEFT ================= */}
//         <div className="col-md-8">
//           <div className="border p-4 rounded-2">
//             <h6 className="fw-bold mb-3">Billing Information</h6>

//             <div className="row mb-3">
//               <div className="col-md-6">
//                 <input
//                   name="first_name"
//                   value={form.first_name}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="First Name"
//                   disabled={!userId}
//                 />
//               </div>
//               <div className="col-md-6">
//                 <input
//                   name="last_name"
//                   value={form.last_name}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="Last Name"
//                   disabled={!userId}
//                 />
//               </div>
//             </div>

//             <input
//               name="company_name"
//               value={form.company_name}
//               onChange={handleChange}
//               className="form-control mb-3"
//               placeholder="Company Name"
//               disabled={!userId}
//             />

//             <h6 className="fw-bold mb-3">ADDRESS</h6>

//             <input
//               name="pin_code"
//               value={form.pin_code}
//               onChange={handleChange}
//               className="form-control mb-2"
//               placeholder="Pin Code"
//               disabled={!userId}
//             />
//             <input
//               name="address1"
//               value={form.address1}
//               onChange={handleChange}
//               className="form-control mb-2"
//               placeholder="Address"
//               disabled={!userId}
//             />
//             <input
//               name="location"
//               value={form.location}
//               onChange={handleChange}
//               className="form-control mb-2"
//               placeholder="Location"
//               disabled={!userId}
//             />

//             <div className="row mb-3">
//               <div className="col-md-6">
//                 <input
//                   name="city"
//                   value={form.city}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="City"
//                   disabled={!userId}
//                 />
//               </div>
//               <div className="col-md-6">
//                 <input
//                   name="state"
//                   value={form.state}
//                   onChange={handleChange}
//                   className="form-control"
//                   placeholder="State"
//                   disabled={!userId}
//                 />
//               </div>
//             </div>

//             <button
//               onClick={addAddress}
//               disabled={!userId}
//               className="bg-col text-white w-100 py-2 border-0 rounded-2 fw-bold mb-4"
//             >
//               ADD ADDRESS
//             </button>

//             {!userId && (
//               <small className="text-danger d-block text-center">
//                 Please login to add address
//               </small>
//             )}

//             {/* ================= SAVED ADDRESSES ================= */}
//             {userId && (
//               <>
//                 <h6 className="fw-bold mb-3">SAVED ADDRESSES</h6>

//                 {addresses.length === 0 && (
//                   <p>No saved addresses found.</p>
//                 )}

//                 {addresses.map((addr) => (
//                   <div
//                     key={addr.billing_id}
//                     className="border rounded-2 p-3 mb-3 d-flex justify-content-between"
//                   >
//                     <label className="d-flex gap-2">
//                       <input
//                         type="radio"
//                         name="selectAddress"
//                         onChange={() => setSelectedAddress(addr)}
//                       />
//                       <div>
//                         <p className="mb-1">{addr.address1}</p>
//                         <small>
//                           {addr.city}, {addr.state} - {addr.pin_code}
//                         </small>
//                         <div className="fw-bold text-capitalize">
//                           {addr.address_type}
//                         </div>
//                       </div>
//                     </label>

//                     <button
//                       onClick={() => setSelectedAddress(addr)}
//                       className="bg-col text-white border-0 px-3 py-1 rounded-2"
//                     >
//                       DELIVER HERE
//                     </button>
//                   </div>
//                 ))}
//               </>
//             )}
//           </div>
//         </div>

//         {/* ================= RIGHT ================= */}
//         {userId && (
//           <div className="col-md-4 py-5">
//             <div className="border p-4 shadow-sm">
//               <h5>Order Summary</h5>

//               {cartItems.map((item) => (
//                 <div
//                   key={item.cart_id}
//                   className="d-flex justify-content-between"
//                 >
//                   <span>{item.Product_name}</span>
//                   <span>
//                     {item.cart_qty} × ₹{item.current_price}
//                   </span>
//                 </div>
//               ))}

//               <hr />
//               <strong>Total ₹{totalAmount}</strong>

//               <button
//                 disabled={!selectedAddress}
//                 onClick={handlePayment}
//                 className="bg-col border-0 p-2 w-100 mt-3 rounded text-white fw-bold"
//               >
//                 Payment Continue
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default BillingStatic;




import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const BASE_URL = "https://ecom.cyberathon.com";

function BillingStatic() {
  const navigate = useNavigate();

  const userId = sessionStorage.getItem("userId");
  const cartToken = localStorage.getItem("cart_token");

  /* ================= ALERT STATE ================= */
  const [alertShown, setAlertShown] = useState(false);

  /* ================= CART ================= */
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    if (!userId && !cartToken) return;

    axios
      .post(`${BASE_URL}/index.php/Api/list_cart`, {
        user_id: userId ? userId : null,
        cart_token: userId ? null : cartToken,
      })
      .then((res) => {
        if (res.data.status) {
          setCartItems(res.data.cart_items);
        } else {
          setCartItems([]);
        }
      });
  }, [userId, cartToken]);

  const totalAmount = cartItems.reduce(
    (sum, i) => sum + Number(i.current_price) * Number(i.cart_qty),
    0
  );

  /* ================= LOGIN POPUP ================= */
  useEffect(() => {
    if (!userId && !alertShown) {
      window.alert("Please login to continue");
      setAlertShown(true);
    }
  }, [userId, alertShown]);

  /* ================= FORM ================= */
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email:"",
    phone:"",
    company_name: "",
    address1: "",
    location: "",
    city: "",
    state: "",
    pin_code: "",
    email: "",
    phone: "",
    address_type: "home",
    add_information: "",
  });

  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);

  /* ================= FETCH ADDRESSES (ONLY LOGIN) ================= */
  useEffect(() => {
    if (!userId) return;

    axios
      .post(`${BASE_URL}/index.php/Api/list_billing_address`, {
        user_id: userId,
      })
      .then((res) => {
        if (res.data.status) {
          setAddresses(res.data.data || []);
        }
      });
  }, [userId]);

  /* ================= HANDLE INPUT ================= */
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  /* ================= ADD ADDRESS ================= */
  const addAddress = async () => {
    if (!userId) {
      window.alert("Please login to add address");
      return;
    }

    try {
      const payload = { ...form, user_id: userId };
      const res = await axios.post(
        `${BASE_URL}/index.php/Api/add_billing_address`,
        payload
      );

      if (res.data.status) {
        window.alert("Address added successfully");

        setForm({
          first_name: "",
          last_name: "",
          email:"",
          phone:"",
          company_name: "",
          address1: "",
          location: "",
          city: "",
          state: "",
          pin_code: "",
          email: "",
          phone: "",
          address_type: "home",
          add_information: "",
        });

        // reload addresses
        const list = await axios.post(
          `${BASE_URL}/index.php/Api/list_billing_address`,
          { user_id: userId }
        );
        if (list.data.status) setAddresses(list.data.data || []);
      }
    } catch (err) {
      console.error(err);
      window.alert("Failed to add address");
    }
  };

  /* ================= AUTO FILL FROM SESSION ================= */
useEffect(() => {
  if (!userId) return;

  setForm((prev) => ({
    ...prev,
    first_name: sessionStorage.getItem("first_name") || "",
    last_name: sessionStorage.getItem("last_name") || "",
    email: sessionStorage.getItem("email") || "",
    phone: sessionStorage.getItem("phone") || "",
  }));
}, [userId]);


  return (
    <div className="container my-5">
      <h4 className="fw-bold mb-4">BILLING DETAILS</h4>

      <div className="row g-4">
        {/* ================= LEFT ================= */}
        <div className="col-md-8">
          <div className="border p-4 rounded-2">

            <h6 className="fw-bold mb-3">Billing Information</h6>

            <div className="row mb-3">
              <div className="col-md-6">
                <input
                  name="first_name"
                  value={form.first_name}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="First Name"
                  disabled={!userId}
                />
              </div>
              <div className="col-md-6">
                <input
                  name="last_name"
                  value={form.last_name}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Last Name"
                  disabled={!userId}
                />
              </div>
            </div>
             <div className="row mb-3">
              <div className="col-md-6">
                <input
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="email"
                  disabled={!userId}
                />
              </div>
              <div className="col-md-6">
                <input
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="phone"
                  disabled={!userId}
                />
              </div>
            </div>

            <input
              name="company_name"
              value={form.company_name}
              onChange={handleChange}
              className="form-control mb-3"
              placeholder="Company Name"
              disabled={!userId}
            />

            <h6 className="fw-bold mb-3">ADDRESS</h6>

            <input
              name="pin_code"
              value={form.pin_code}
              onChange={handleChange}
              className="form-control mb-2"
              placeholder="Pin Code"
              disabled={!userId}
            />
            <input
              name="address1"
              value={form.address1}
              onChange={handleChange}
              className="form-control mb-2"
              placeholder="Address"
              disabled={!userId}
            />
            <input
              name="location"
              value={form.location}
              onChange={handleChange}
              className="form-control mb-2"
              placeholder="Location"
              disabled={!userId}
            />

            <div className="row mb-3">
              <div className="col-md-6">
                <input
                  name="city"
                  value={form.city}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="City"
                  disabled={!userId}
                />
              </div>
              <div className="col-md-6">
                <input
                  name="state"
                  value={form.state}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="State"
                  disabled={!userId}
                />
              </div>
            </div>

            <strong>ADDRESS TYPE</strong>
            <div className="mb-3">
              <label className="me-3">
                <input
                  type="radio"
                  checked={form.address_type === "home"}
                  onChange={() =>
                    setForm({ ...form, address_type: "home" })
                  }
                  disabled={!userId}
                />{" "}
                Home
              </label>
              <label>
                <input
                  type="radio"
                  checked={form.address_type === "office"}
                  onChange={() =>
                    setForm({ ...form, address_type: "office" })
                  }
                  disabled={!userId}
                />{" "}
                Office
              </label>
            </div>

            <button
              onClick={addAddress}
              className="bg-col text-white w-100 py-2 border-0 rounded-2 fw-bold mb-4"
              disabled={!userId}
            >
              ADD ADDRESS
            </button>

            {/* ================= SAVED ADDRESSES ================= */}
            {userId && (
              <>
                <h6 className="fw-bold mb-3">SAVED ADDRESSES</h6>

                {addresses.length === 0 && (
                  <p>No saved address found.</p>
                )}

                {addresses.map((addr) => (
                  <div
                    key={addr.billing_id}
                    className="border rounded-2 p-3 d-flex justify-content-between mb-3"
                  >
                    <label className="d-flex gap-2">
                      <input
                        type="radio"
                        name="selectAddress"
                        checked={selectedAddress?.billing_id === addr.billing_id}
                        onChange={() => setSelectedAddress(addr)}
                      />
                      <div>
                      <p className="mb-1 fw-semibold">{addr.first_name} {addr.last_name}</p>
                        <p className="mb-1">{addr.address1}</p>
                        <small>
                          {addr.city}, {addr.state} - {addr.pin_code}
                        </small>
                        <div className="fw-bold text-capitalize">
                          {addr.address_type}
                        </div>
                      </div>
                    </label>

                     <button
                     type="button"
                      onClick={() => {
                        setSelectedAddress(addr);
                        
                      }}
                      className="bg-col text-white border-0 delieverbutton rounded-2"
                    >
                      DELIVER HERE
                    </button> 
                    
                  </div>
                ))}
              </>
            )}
          </div>
        </div>

        {/* ================= RIGHT ================= */}
        <div className="col-md-4 py-5">
          {userId && (
            <div className="border p-4 shadow-sm">
              <h5>Order Summary</h5>

              {cartItems.map((item) => (
                <div
                  key={item.cart_id}
                  className="d-flex justify-content-between"
                >
                  <span>{item.Product_name}</span>
                  <span>
                    {item.cart_qty} x ₹{item.current_price}
                  </span>
                </div>
              ))}

              <hr />
              
              {/* <strong>Total ₹{totalAmount}</strong> */}
               {/* Shipping */}
  <div className="d-flex justify-content-between mb-2">
    <span>Shipping</span>
    <span>₹0</span>
  </div>

  {/* Total */}
  <div className="d-flex justify-content-between fw-bold ">
    <span>Total</span>
    <span>₹{totalAmount}</span>
  </div>

  {/* Continue Button */}
  <button
    className="bg-col text-white w-100 py-2 mt-4 border-0 rounded-2 fw-bold"
    onClick={() => {
      
      navigate("/payment");
    }}
  >
    CONTINUE PAYMENT
  </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default BillingStatic;
